'use strict'

import { firebaseStore } from '@/libs/firebase'

const get = async () => {
  const data = await firebaseStore.get('sample', 'tab')
  return Promise.resolve(data)
}

export default {
  get
}
